package com.schoolconnect.app.feature.attendance

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogBody
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFieldRow
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogSelectField
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOrangeSoft
import com.schoolconnect.app.designsystem.AppOrangeText
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTypography
import com.schoolconnect.app.designsystem.list.AdminStatusChip
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.pageWindow
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.refresh_cw
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun AttendanceHistoryDialog(
    student: AttendanceInsightRowUi,
    onDismiss: () -> Unit
) {
    val viewModel = remember(student.key) { AttendanceHistoryViewModel(student.key) }
    val state by viewModel.uiState.collectAsState()
    var statusExpanded by remember(student.key) { mutableStateOf(false) }
    var rowsPerPageExpanded by remember(student.key) { mutableStateOf(false) }
    androidx.compose.runtime.DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }
    val window = pageWindow(state.pageIndex, state.pageSize, state.totalCount)

    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        dialogWidthOverride = 1440.dp,
        maxDialogHeight = 900.dp
    ) {
        AppDialogHeader(
            title = "Attendance History",
            subtitle = "${student.studentName}   |   Roll No: ${student.rollNumber}   |   Class: ${student.classLabel}",
            onClose = onDismiss,
            height = 92.dp
        )
        HorizontalDivider(color = AppBorder)
        AppDialogBody(horizontalPadding = 28.dp, verticalPadding = 8.dp) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                HistoryMetricCard("Total Days", state.totalDays.toString(), "Days", Res.drawable.calendar, AppPrimary, AppPrimarySoft)
                HistoryMetricCard("Attendance %", "${state.attendancePercentage}%", "", Res.drawable.users, AppSuccess, AppSuccessSoft)
                HistoryMetricCard("Present", state.presentDays.toString(), "Days", Res.drawable.circle_check, AppSuccess, AppSuccessSoft)
                HistoryMetricCard("Absent", state.absentDays.toString(), "Days", Res.drawable.ban, AppDanger, AppDangerSoft)
            }

            AppCard(
                modifier = Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)),
                containerColor = Color.White
            ) {
                AppDialogFieldRow(spacing = 18.dp, modifier = Modifier.padding(12.dp)) {
                    AppDialogFieldColumn(label = "From Date", modifier = Modifier.weight(1f)) {
                        AppDialogDateField(state.fromDate, { viewModel.onEvent(AttendanceHistoryUiEvent.FromDateChanged(it)) }, Modifier.fillMaxWidth(), colors = AppDialogDefaultColors, fieldHeight = 46.dp, fontSize = 14.sp)
                    }
                    AppDialogFieldColumn(label = "To Date", modifier = Modifier.weight(1f)) {
                        AppDialogDateField(state.toDate, { viewModel.onEvent(AttendanceHistoryUiEvent.ToDateChanged(it)) }, Modifier.fillMaxWidth(), colors = AppDialogDefaultColors, fieldHeight = 46.dp, fontSize = 14.sp)
                    }
                    AppDialogFieldColumn(label = "Attendance Status", modifier = Modifier.weight(1f)) {
                        AppDialogSelectField(
                            value = state.selectedStatus,
                            placeholder = "All",
                            expanded = statusExpanded,
                            options = listOf("All") + com.schoolconnect.app.repository.systemlookup.SystemLookupOptions
                                .codes("ATTENDANCE_STATUS")
                                .filterNot { it.equals("All", ignoreCase = true) },
                            onToggleExpanded = { statusExpanded = !statusExpanded },
                            onDismissExpanded = { statusExpanded = false },
                            onSelected = { viewModel.onEvent(AttendanceHistoryUiEvent.StatusChanged(it)); statusExpanded = false },
                            fieldHeight = 46.dp,
                            fontSize = 14.sp
                        )
                    }
                    Button(
                        onClick = { viewModel.onEvent(AttendanceHistoryUiEvent.ApplyClicked) },
                        modifier = Modifier.padding(top = 31.dp).width(116.dp).height(46.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = AppPrimary),
                        shape = RoundedCornerShape(8.dp)
                    ) {
                        Icon(painterResource(Res.drawable.filter), null, Modifier.size(18.dp))
                        Spacer(Modifier.width(8.dp))
                        Text("Apply", fontWeight = FontWeight.Bold)
                    }
                    OutlinedButton(
                        onClick = { viewModel.onEvent(AttendanceHistoryUiEvent.ClearClicked) },
                        modifier = Modifier.padding(top = 31.dp).width(116.dp).height(46.dp),
                        shape = RoundedCornerShape(8.dp)
                    ) {
                        Icon(painterResource(Res.drawable.refresh_cw), null, Modifier.size(18.dp), tint = AppPrimary)
                        Spacer(Modifier.width(8.dp))
                        Text("Clear", color = AppPrimary, fontWeight = FontWeight.Bold)
                    }
                }
            }

            HistoryStatusLegend()

            AdminListTableCard(
                // AdminListTableCard uses weighted header/body content. The
                // dialog body is scrollable and therefore unbounded, so give
                // the ledger an explicit viewport to keep rows visible.
                modifier = Modifier.fillMaxWidth().height(390.dp),
                surfaceColor = Color.White,
                borderColor = AppBorder,
                minContentWidth = 760.dp,
                header = {
                    AdminListHeaderRow(listOf(
                        AdminListHeaderColumn("Date", 1.1f),
                        AdminListHeaderColumn("Day", .9f),
                        AdminListHeaderColumn("Status", .9f),
                        AdminListHeaderColumn("Remarks", 2.3f)
                    ))
                },
                body = {
                    if (state.isLoading) {
                        Box(Modifier.fillMaxWidth().padding(30.dp), contentAlignment = Alignment.Center) {
                            Text("Loading attendance history…", color = AppMuted, fontSize = AdminListTypography.TableBody)
                        }
                    } else if (state.errorMessage.isNotBlank()) {
                        Box(Modifier.fillMaxWidth().padding(30.dp), contentAlignment = Alignment.Center) {
                            AppDialogErrorMessage(state.errorMessage)
                        }
                    } else if (state.ledger.isEmpty()) {
                        Box(Modifier.fillMaxWidth().padding(30.dp), contentAlignment = Alignment.Center) {
                            Text("No attendance history found", color = AppMuted, fontSize = AdminListTypography.TableBody)
                        }
                    } else {
                        AdminListTableBody(items = state.ledger, key = { "${it.date}-${it.status}" }, modifier = Modifier.fillMaxWidth()) { row ->
                            HistoryTableRow(row)
                            if (row != state.ledger.last()) HorizontalDivider(color = AppBorder)
                        }
                    }
                },
                footer = {
                    AdminListFooter(
                        pageText = pageFooterText(window, "records"),
                        pageIndex = window.pageIndex,
                        pageCount = window.pageCount,
                        onPageChanged = { viewModel.onEvent(AttendanceHistoryUiEvent.PageChanged(it)) },
                        pageSize = state.pageSize,
                        rowsPerPageExpanded = rowsPerPageExpanded,
                        onRowsPerPageToggle = { rowsPerPageExpanded = !rowsPerPageExpanded },
                        onRowsPerPageDismiss = { rowsPerPageExpanded = false },
                        onPageSizeChanged = { viewModel.onEvent(AttendanceHistoryUiEvent.PageSizeChanged(it)) }
                    )
                }
            )
        }
        HorizontalDivider(color = AppBorder)
        AppDialogFooter(
            actions = listOf(AppDialogFooterAction("Close", onDismiss, AppDialogActionStyle.Secondary)),
            footerHeight = 64.dp
        )
    }
}

@Composable
private fun RowScope.HistoryMetricCard(
    title: String,
    value: String,
    subtitle: String,
    icon: DrawableResource,
    accent: Color,
    soft: Color
) {
    AppCard(
        modifier = Modifier.weight(1f).height(112.dp).border(1.dp, accent.copy(alpha = .18f), RoundedCornerShape(10.dp)),
        containerColor = Color.White
    ) {
        Row(Modifier.fillMaxWidth().padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(Modifier.size(42.dp).background(soft, RoundedCornerShape(50)), contentAlignment = Alignment.Center) {
                Icon(painterResource(icon), null, Modifier.size(22.dp), tint = accent)
            }
            Spacer(Modifier.width(10.dp))
            Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(title, color = AppNavy, fontSize = AdminListTypography.SummaryTitle, fontWeight = AdminListTypography.SummaryTitleWeight)
                Text(value, color = accent, fontSize = 25.sp, fontWeight = FontWeight.ExtraBold)
                if (subtitle.isNotBlank()) Text(subtitle, color = AppNavy, fontSize = AdminListTypography.SummarySubtitle)
            }
        }
    }
}

@Composable
private fun HistoryStatusLegend() {
    AppCard(
        modifier = Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)),
        containerColor = Color.White
    ) {
        Row(Modifier.fillMaxWidth().padding(horizontal = 18.dp, vertical = 10.dp), horizontalArrangement = Arrangement.spacedBy(18.dp), verticalAlignment = Alignment.CenterVertically) {
            HistoryLegendItem("P", "Present")
            HistoryLegendItem("A", "Absent")
            HistoryLegendItem("A-M", "Absent Morning")
            HistoryLegendItem("A-A", "Absent Afternoon")
        }
    }
}

@Composable
private fun RowScope.HistoryLegendItem(code: String, label: String) {
    Row(Modifier.weight(1f), horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
        Text(code, color = AppNavy, fontSize = AdminListTypography.TableBody, fontWeight = AdminListTypography.TableBodyWeight)
        Text("= $label", color = AppNavy, fontSize = AdminListTypography.TableBody, fontWeight = AdminListTypography.TableBodyWeight)
    }
}

@Composable
private fun HistoryTableRow(row: AttendanceHistoryLedgerUi) {
    Row(Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 10.dp), verticalAlignment = Alignment.CenterVertically) {
        HistoryCell(row.date, 1.1f)
        HistoryCell(row.day, .9f)
        Box(Modifier.weight(.9f).padding(horizontal = 8.dp), contentAlignment = Alignment.CenterStart) { HistoryStatusChip(row.status) }
        HistoryCell(row.remarks.ifBlank { "–" }, 2.3f)
    }
}

@Composable
private fun RowScope.HistoryCell(text: String, weight: Float) {
    AdminListTableBodyText(text = text, modifier = Modifier.weight(weight).padding(horizontal = 8.dp), color = AppNavy, fontWeight = AdminListTypography.TableBodyWeight)
}

@Composable
private fun HistoryStatusChip(status: String) {
    AdminListTableBodyText(
        text = status,
        color = AppNavy,
        fontWeight = AdminListTypography.TableBodyWeight
    )
}
